import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { openWishlistModal } from '../../store/slices/wishlistModalSlice'
import {
  hideAddedItemNotification,
  selectAddedItemNotification,
} from '../../store/slices/wishlistSlice'
import styles from './AddToWishlistNotification.module.css'

const AddToWishlistNotification = () => {
  const dispatch = useDispatch()
  const notification = useSelector(selectAddedItemNotification)
  const [isHiding, setIsHiding] = useState(false)

  // Ефект для автоматичного приховування повідомлення
  useEffect(() => {
    if (notification.show) {
      const timer = setTimeout(() => {
        setIsHiding(true)
        setTimeout(() => {
          dispatch(hideAddedItemNotification())
          setIsHiding(false)
        }, 300) // Час анімації зникнення
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [notification.show, dispatch])

  const handleCloseNotification = useCallback(() => {
    setIsHiding(true)
    setTimeout(() => {
      dispatch(hideAddedItemNotification())
      setIsHiding(false)
    }, 300) // Час анімації зникнення
  }, [dispatch])

  const handleViewWishlist = useCallback(() => {
    dispatch(openWishlistModal())
    setIsHiding(true)
    setTimeout(() => {
      dispatch(hideAddedItemNotification())
      setIsHiding(false)
    }, 300) // Час анімації зникнення
  }, [dispatch])

  if (!notification.show || !notification.item) {
    return null
  }

  return (
    <div className={`${styles.addToWishlistNotification} ${isHiding ? styles.hiding : ''}`}>
      <button
        className={styles.closeButton}
        onClick={e => {
          e.stopPropagation()
          handleCloseNotification()
        }}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.666016"
            y="0.666504"
            width="16.6667"
            height="16.6667"
            rx="4.16667"
            stroke="#BFBFBF"
            strokeWidth="1.25"
          />
          <path
            d="M7.23204 10.768L10.7676 7.23242"
            stroke="#BFBFBF"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.23204 7.23253L10.7676 10.7681"
            stroke="#BFBFBF"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <div className={styles.addToWishlistIcon}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5 2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z"
            fill="#FF7000"
          />
        </svg>
      </div>
      <div className={styles.addToWishlistText}>
        <span className={styles.addToWishlistTitle}>
          {notification.item.name} додано до вішлисту
        </span>
        <button
          className={styles.addToWishlistButton}
          onClick={e => {
            e.stopPropagation()
            handleViewWishlist()
          }}
        >
          Переглянути
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="15"
            viewBox="0 0 9 15"
            fill="none"
          >
            <path
              d="M1.1665 0.5V0.5C1.1665 4.36283 4.30344 7.49908 8.16625 7.48872V7.48872"
              stroke="#FF7000"
              strokeWidth="1.5"
            />
            <path
              d="M1.1665 14.5V14.5C1.1665 10.6372 4.30344 7.50092 8.16625 7.51128V7.51128"
              stroke="#FF7000"
              strokeWidth="1.5"
            />
          </svg>
        </button>
      </div>
      <div className={styles.addToWishlistArrow}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M6 4L10 8L6 12"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  )
}

export default AddToWishlistNotification
